import { Avatar, Tooltip } from "@mui/material";
import { stringToColor } from "../../lib/util";

interface ProfileIconProps {
  userName: string;
  width?: string;
  height?: string;
}

export default function ProfileIcon(props: ProfileIconProps) {
  let width = "40px";
  let height = "40px";

  if (props.height) {
    height = props.height;
  }

  if (props.width) {
    width = props.width;
  }

  const { userName = "My Name" } = props;

  const nameAbb = (name: string) => {
    if (name.split(" ").length > 1) {
      return (
        name.split(" ")[0][0] + name.split(" ")[name.split(" ").length - 1][0]
      ).toUpperCase();
    } else if (name.length > 1) {
      return (name[0] + name[1]).toUpperCase();
    } else {
      return name[0].toUpperCase();
    }
  };

  function stringAvatar(name: string) {
    return {
      sx: {
        fontSize: "18px",
        fontWeight: "500",
        bgcolor: stringToColor(name),
        width: width,
        height: height,
      },
      children: nameAbb(name),
    };
  }

  return (
    <Tooltip title={userName} arrow>
      <Avatar {...stringAvatar(userName)} />
    </Tooltip>
  );
}
